import React from 'react';
import './marker.sass';

export const Marker = ({text, number, isActive}) => {

    return (
        <div className='vv-vendor-marker'>
            <div className={`vv-vendor-marker__mark ${isActive ? 'vv-vendor-marker__mark--active' : ''}`}>
                <p>{number}</p>
            </div>
            <div className={`vv-vendor-marker__label ${isActive ? 'vv-vendor-marker__label--active' : ''}`}>
                <p>{text}</p>
            </div>
        </div>
    );
};